import type { Workspace, WorkspaceBase } from '@eci-saas/shared'

export const useWorkspaceStore = defineStore(
  'lcms_workspace',
  () => {
    const workspaceList = ref<Workspace[]>([])
    const currentWorkspace = ref<Workspace | null>(null)

    const workspaceCount = computed(() => workspaceList.value.length)
    const workspaceOptions = computed<WorkspaceBase[]>(() =>
      workspaceList.value.map(({ id, name, description, iconUrl, currency }) => ({
        id,
        name,
        description,
        iconUrl,
        currency,
      })),
    )

    const setCurrentWorkspace = (workspace: Workspace) => {
      currentWorkspace.value = workspace
    }

    const getWorkspaceById = (id: number) => {
      return workspaceList.value.find(w => w.id === id)
    }

    const reset = () => {
      workspaceList.value = []
      currentWorkspace.value = null
    }

    return {
      workspaceList,
      currentWorkspace,
      workspaceCount,
      workspaceOptions,
      setCurrentWorkspace,
      getWorkspaceById,
      reset,
    }
  },
  {
    persist: true,
  },
)
